import React from "react";
import Environment from "~/common/Environment";
import { InternalNotesData } from "./InternalNotesResult";
import InternalNotesVirtualGroupSelect from "./InternalNotesVirtualGroupSelect";
interface Props {
  isVirtual: boolean;
  selectedItemNumber: string;
  groupItemNumber: string;
  groupingItemNumbers: string[];
  setSelectedItemNumber: React.Dispatch<React.SetStateAction<string>>;
  internalNotesData: InternalNotesData;
}
const InternalNotesHeader = ({
  isVirtual,
  selectedItemNumber,
  groupItemNumber,
  groupingItemNumbers,
  setSelectedItemNumber,
  internalNotesData
}: Props) => {
  const {
    vendorCode,
    vendorItemNumber,
    vendorNonDmsItemNumber,
    substituteItemNumber,
    isAutomaticReorderEligible
  } = internalNotesData;
  return <div className="wi-head" data-testid="internalNotesHeader" data-sentry-component="InternalNotesHeader" data-sentry-source-file="InternalNotesHeader.tsx">
      {isVirtual ? <InternalNotesVirtualGroupSelect groupItemNumber={groupItemNumber} groupingItemNumbers={groupingItemNumbers} selectedItemNumber={selectedItemNumber} setSelectedItemNumber={setSelectedItemNumber} /> : <div>
          <h3>
            <a href={`https://adminportal.${Environment.domainWithEnvironment}/External/Item%20Detail%20Page/ItemDetailPage?itemNumber=${encodeURIComponent(selectedItemNumber)}`} target="_blank" rel="noopener noreferrer">
              #{selectedItemNumber}
            </a>
            &nbsp;
            {isAutomaticReorderEligible && <i className="icon-video icon-history" data-toggle="tooltip" title="Auto-reorder eligible" data-testid="auto-reorder-icon-internal" />}
          </h3>
        </div>}
      <h4>
        <a href={`https://enterprisereports.prod.clarkinc.biz/ReportServer/Pages/ReportViewer.aspx?/Customer%20Service/OrderItemComplaintsReport&item_number=${encodeURIComponent(selectedItemNumber)}&start_date:isnull=true&end_date:isnull=true`} target="_blank" rel="noopener noreferrer">
          Complaint Log
        </a>
      </h4>
      {vendorCode && <dl className="wi-meta wi-meta--vendorid">
          <dt>Vendor ID</dt>
          <dd>
            <a href={`https://adminportal.${Environment.domainWithEnvironment}/Content/BrandManagement/VendorCode?code=${vendorCode}`} target="_blank" rel="noopener noreferrer">
              #{vendorCode}
            </a>
          </dd>
        </dl>}
      {vendorItemNumber && <dl className="wi-meta wi-meta--vendoritem">
          <dt>Vendor Item</dt>
          <dd>{vendorItemNumber}</dd>
        </dl>}
      {vendorNonDmsItemNumber && <dl className="wi-meta wi-meta--vendornondms">
          <dt>NON-DMS VENDOR ITEM</dt>
          <dd>{vendorNonDmsItemNumber}</dd>
        </dl>}
      {substituteItemNumber && <dl className="wi-meta wi-meta--vendoritem">
          <dt>#{substituteItemNumber}</dt>
          <dd>
            <img src="/newwebadmin/images/subArrowsIcon.png" alt="substitute item number" title="sub item" />
          </dd>
        </dl>}
      {isAutomaticReorderEligible && isVirtual && <dl className="wi-meta wi-meta--vendoritem">
          <i className="icon-video icon-history" data-toggle="tooltip" title="Auto-reorder eligible" data-testid="auto-reorder-icon-internal" />
        </dl>}
    </div>;
};
export default InternalNotesHeader;